import { observer } from 'mobx-react-lite'
import { AgentSwitchField } from 'entities/AIAgent/ui/AgentSwitchField/AgentSwitchField.tsx'
import { useChatbotContext } from 'pages/chatbot/context'

export const PointAIQualify = observer(() => {
  const {
    model: { settings },
  } = useChatbotContext()
  const handleQualifyEnabledChange = (status: boolean) => {
    settings.setQualifyEnabled(status)
  }
  return (
    <AgentSwitchField
      active={settings.qualifyEnabled}
      onChange={handleQualifyEnabledChange}
      title={'AI Qualify'}
      isBeta
    />
  )
})
